export default __webpack_public_path__ + "static/media/ScottFranklin.70c65808.png";